
import {
    cardOrderExport,
    permissionList,
    purchaseCopeExport,
    getStoreVipCardList,
    getStoreVipClassList,
    giveOutVipCard,
    editUserVipCard,
    deleteUserVipCard,
    getBranchStoreList, getCardUseLogDetail, getSpecialTotalList, memberCardListExport
} from "@/api/http";


const columnList: Array<any> = [
    {
        prop: "id",
        label: "会员卡ID",
        width: 80,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 80,
    },
    {
        prop: "phone",
        label: "会员手机",
        width: 100,
    },
    {
        prop: "store_name",
        label: "发放门店",
        width: 100,
    },
    {
        prop: "card_name",
        label: "尊享卡名称",
        width: 100,
    },
    {
        prop: "price",
        label: "售价",
        width: 80,
    },
    {
        prop: "status_text",
        label: "使用状态",
        width: 80,
    },
    {
        prop: "end_time_text",
        label: "到期时间",
        width: 80,
    },
    {
        prop: "create_time_text",
        label: "发放时间",
        width: 80,
    },
];

import { defineComponent, inject, ref, onMounted, reactive, watch } from "vue";
import { Throttle } from "@/api/api";
import { Request } from "@/api/request";
import { validateInput } from "@/assets/js/formRules";
import {ElLoading, ElMessageBox} from "element-plus";
export default defineComponent({
    name: "orderCard",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["会员尊享卡"]);
        const headClass = inject("headClass");
        let loading = ref(false),
            dialog_show = ref(''),
            roleList = ref({} as any),
            tableData = ref([] as Array<any>),
            detailTable = ref([] as Array<any>),
            desc = ref(''),
            currentPage = ref(1),
            pageSize = ref(10),
            total = ref(0),
            formRef = ref(null),
            store_ids = ref([]),
            payTypeList = ref([]),
            //消费记录
            recordData = reactive({
                recordDialogShow:false,
                recordList:[]
            }),
            screenParameter: any = ref({
                search: "",
                time: "",
                start_time: null,
                end_time: null,
                store_id:null,
                vip_card_id:null
            }),
            //门店尊享卡列表
            vipCardList = ref([
                {
                    id:'0',
                    title:'请选择尊享卡',
                }
            ]),
            //门店尊享卡项目列表
            vipClassList = ref([]),
            form: any = ref({
                phone: "",
                vip_card_id: '0',
                start_time: '',
                start_time_text: '',
                end_time: '',
                end_time_text: '',
                vip_class_ids: '',
                surplus_numbers: '',
                store_ids:"",
                id:'',
                payType:'',
                is_history:0,
                price:0,
                desc:''
            }),
            dialogTitle = ref(""),
            dialogFormVisible = ref(false),
            orderDetail: any = ref({}),
            dialogNavIndex = ref(0),
            dialogWriteoffList = ref([] as Array<any>),
            dialogWriteoffId = ref(null),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入核销码", value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        
        let getTableData = () => {
                let mydata = {
                    type:1,
                    role_name:'member_card',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                let start_time = screenParameter.value.time?Math.floor(new Date(screenParameter.value.time[0]).getTime()/1000):"";
                let end_time = screenParameter.value.time ?Math.floor((new Date(screenParameter.value.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                let data: any = {
                    ...screenParameter.value,
                    page: currentPage.value,
                    pagesize: pageSize.value,
                    start_time:start_time,
                    end_time:end_time
                };
                loading.value = true;
                Request.axiosInstance({
                    url: "adminapi/User/memberCardList",
                    data,
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            addCard = () => {
                vipClassList.value = [];
                form.value = {
                    phone: '',
                    start_time: '',
                    vip_card_id:'',
                    start_time_text: '',
                    end_time: '',
                    end_time_text: '',
                    store_ids:''
                };
            if (formRef.value){
                (formRef.value as any).resetFields();
            }
                dialog_show.value = 'add';
            },
            selectCard = (e:any) => {
                form.value.vip_card_id = e
                // 获取尊享卡项目列表
                getVipClass(form.value.vip_card_id);
            },
            selectStartTime = (e:any) => {
                form.value.start_time_text = e
                form.value.start_time = new Date(e).getTime() / 1000;
            },
            selectEndTime = (e:any) => {
                form.value.end_time_text = e
                form.value.end_time = new Date(e).getTime() / 1000;
            },
            // 获取门店所有尊享卡列表
            getVipCard = (): void => {
                getStoreVipCardList({}).then((res: any)=>{
                    vipCardList.value = vipCardList.value.concat(res?.content?.list || []);
                })
            },
            // 获取门店所有尊享卡项目列表
            getVipClass = (vipCardId:number): void => {
                getStoreVipClassList({vip_card_id:vipCardId}).then((res: any)=>{
                    vipClassList.value = res?.content?.list || [];
                })
            },
            // 编辑剩余次数
            surplusChange = (e: number,index:number): void => {
                if(e > (vipClassList.value as any)[index]['number']){
                    (vipClassList.value as any)[index]['surplus_number'] = (vipClassList.value as any)[index]['number'];
                }else if(e < 0){
                    (vipClassList.value as any)[index]['surplus_number'] = 0;
                }else{
                    (vipClassList.value as any)[index]['surplus_number'] = e;
                }
            },
            // 切换每页数量大小
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            // 切换分页
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            searchClick = ()=> {
                getTableData();
            },
            // 提交事件
            _formSubmit = new Throttle().use(()=> {
                let data = form.value;
                // 遍历获取对应的门店尊享卡项目id、剩余次数
                let vipClassIdList: any = [];
                let surplusNumberList: any = [];
                vipClassList.value.forEach((vipClass: any) => {
                    vipClassIdList.push(vipClass.id);
                    surplusNumberList.push(vipClass.surplus_number);
                });
                data['vip_class_ids'] = vipClassIdList.join(",");
                data['surplus_numbers'] = surplusNumberList.join(",");
                data['store_list'] = form.value.store_ids.toString();
                if(dialog_show.value == 'edit'){
					editUserVipCard(data).then((res:any)=>{
					    if (res.status == 202) {
					        dialog_show.value = '';
					        getTableData();
					    }
					});
				}else{
					giveOutVipCard(data).then((res:any)=>{
					    if (res.status == 202) {
					        dialog_show.value = '';
					        getTableData();
					    }
					});
				}
            },3000),
            screenChange = (e: string): void => {
                console.log('e-------',e);
                if (e) {
                    screenParameter.value.start_time = e[0]
                        ? new Date(e[0]).getTime()/1000
                        : null;
                    screenParameter.value.end_time = e[1]
                        ? new Date(e[1]).getTime()/1000
                        : null;
                } else {
                    screenParameter.value.start_time = '';
                    screenParameter.value.end_time = '';
                }
                getTableData();
            },
            writeoff = () => {
                Request.axiosInstance({
                    url: "adminapi/Order/vipwriteoff",
                    data: {
                        order_id: orderDetail.value.id,
                        vip_class_id: dialogWriteoffId.value,
                    },
                }).then((res: any) => {
                    if (res.status == 202) {
                        orderDetail.value.nucleus_pin_code_status = 1;
                        getTableData();
                    }
                });
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
    
                memberCardListExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(()=>{
                    loading.close();
                });
            },
            toDetail = (item: any) => {
				dialogFormVisible.value = true;
				let arr = [[
					'尊享卡名称',
					item.card_name,
					'售价',
					item.price,
					'发放时间',
					item.create_time_text,
				],[
					'会员号',
					item.user_id,
					'会员手机',
					item.phone,
					'到期时间',
					item.end_time_text,
				]];
				orderDetail.value = item;
				desc.value = item.desc;
				detailTable.value = arr;
				Request.axiosInstance({
					url: "adminapi/VipClass/getOrderVipClassList",
					data: {
						id: item.id,
					},
				}).then((res: any) => {
					dialogWriteoffList.value = res?.content?.list || [];
				});
            },
            toEdit = (item: any) => {
				console.log(item)
				vipClassList.value = [];
				if (formRef.value){
					(formRef.value as any).resetFields();
				}
				dialog_show.value = 'edit';
				let need_arr = [];
				for (const arrElement of item.public_store.split(',')) {
					need_arr.push(Number(arrElement));
				}
				form.value = {
					phone: item.phone,
					start_time: item.create_time,
					start_time_text: item.create_time_text,
					end_time: item.end_time,
					end_time_text: item.end_time_text,
					store_ids:need_arr,
					vip_card_id:item.vip_id,
					id:item.id,
                    desc:item.desc
				};
                // 获取尊享卡项目列表
				Request.axiosInstance({
					url: "adminapi/VipClass/getOrderVipClassList",
					data: {
						id: item.id,
					},
				}).then((res: any) => {
                    vipClassList.value = res?.content?.list || [];
				});
            },
            toDelete = (item: any) => {
				if(!confirm("是否确认删除？删除后将无法恢复数据！请谨慎操作！")) return;
				let data = {
					id: item.id,
				}
				deleteUserVipCard(data).then((res:any)=>{
					getTableData();
				})
            },
            toRecord = (item: any) => {
				getCardUseLogDetail({user_id:item.user_id,coupon_id:item.id}).then((res:any)=>{
					if (res.status == 200){
						recordData.recordDialogShow = true;
						recordData.recordList = res.content.list;
					}
				});
            };
        
        onMounted(() => {
            getTableData();
            getVipCard();
            getSpecialTotalList({basicset_type:3}).then((res:any)=>{
                payTypeList.value = res.content.list;
            });
            getBranchStoreList({}).then((res:any)=>{
                store_ids.value = res.content.list;
            });
        });
        // watch(orderStatus, (newValue, oldValue) => {
        //     getTableData();
        // });
        
        return {
            loading,
            tableData,
            addCard,
            selectCard,
            getVipCard,
            getVipClass,
            selectStartTime,
            selectEndTime,
            vipCardList,
            vipClassList,
            surplusChange,
            form,
            _formSubmit,
            dialog_show,
            detailTable,
            desc,
            headClass,
            getTableData,
            currentPage,
            pageSize,
            columnList,
            total,
            handleSizeChange,
            handleCurrentChange,
            dialogTitle,
            dialogFormVisible,
            orderDetail,
            dialogNavIndex,
            dialogWriteoffList,
            dialogWriteoffId,
            rules,
            toDetail,
            toEdit,
            toDelete,
            toRecord,
            screenChange,
            screenParameter,
            writeoff,
            searchClick,
            exportChange,
            roleList,
            store_ids,
            formRef,
            recordData,
            payTypeList
        };
    },
});
